<div class="table-responsive">
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z1 w-100">
    <ng-container matColumnDef="title">
      <th mat-header-cell *matHeaderCellDef i18n>Guest Name</th>
      <td mat-cell *matCellDef="let element">{{ element.title }}</td>
    </ng-container>
    <ng-container matColumnDef="rental">
      <th mat-header-cell *matHeaderCellDef i18n>Rental</th>
      <td mat-cell *matCellDef="let element">
        <app-rental-name [rentalId]="element.rental_id"></app-rental-name>
      </td>
    </ng-container>
    <ng-container matColumnDef="guestArrive">
      <th mat-header-cell *matHeaderCellDef i18n>Arrive</th>
      <td mat-cell *matCellDef="let element">{{ element.guest_arrive | epochUTC }}</td>
    </ng-container>
    <ng-container matColumnDef="guestDepart">
      <th mat-header-cell *matHeaderCellDef i18n>Depart</th>
      <td mat-cell *matCellDef="let element">{{ element.guest_depart | epochUTC }}</td>
    </ng-container>
    <ng-container matColumnDef="personCount">
      <th mat-header-cell *matHeaderCellDef i18n>Count</th>
      <td mat-cell *matCellDef="let element">{{ (element.num_adults || 0) + (element.num_child || 0) }}</td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="onEdit(row)" class="clickable"></tr>
  </table>

  <mat-paginator2
    #paginator
    [length]="$safeNavigationMigration(dataSource?.data?.length)"
    [pageSize]="10"
    [pageSizeOptions]="[5, 10, 20, 50, 75, 100]"
    [showFirstLastButtons]="true"
  >
  </mat-paginator2>
</div>
